import Image from 'next/image'

import { Box, Typography } from '@mui/material'
import PropTypes from 'prop-types'

const ResponsiveImage = (props) => {
    const alt = props.alt?.replace(/ *\{[^)]*\} */g, '')

    const metaWidth = props.alt?.match(/{([^}]+)x/)
    const metaHeight = props.alt?.match(/x([^}]+)}/)
    const width = metaWidth ? Number(metaWidth[1]) : 1000
    const height = metaHeight ? Number(metaHeight[1]) : 500
    const isPriority = props.alt?.toLowerCase().includes('{priority}')
    const hasCaption = props.alt?.toLowerCase().includes('{caption:')

    const caption = props.alt?.match(/{caption: (.*?)}/)?.pop()
    return (
        <Box
            component="span"
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                width: '100%',
            }}
        >
            <Box
                component="span"
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    height: 'auto',
                    width: '90%',
                }}
            >
                <a href={props.src} target="_blank" rel="noopener noreferrer">
                    <Image
                        src={props.src}
                        width={width}
                        height={height}
                        className="postImg"
                        alt={alt}
                        priority={isPriority}
                        sizes="(max-width: 900px) 100vw, 90vw"
                        style={{ width: '100%', height: 'auto' }}
                        loading={isPriority ? 'eager' : 'lazy'}
                    />
                </a>
            </Box>
            {hasCaption && (
                <Box
                    component="span"
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        width: '100%',
                        my: '5px',
                    }}
                >
                    <Typography
                        component="span"
                        variant="caption"
                        textAlign="center"
                    >
                        {caption}
                    </Typography>
                </Box>
            )}
        </Box>
    )
}

ResponsiveImage.propTypes = {
    src: PropTypes.string.isRequired,
    alt: PropTypes.string,
}

export default ResponsiveImage
